var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticStyle:{"float":"right","margin-left":"10px"},attrs:{"size":"mini","type":"info","disabled":_vm.disabled,"to-name":_vm.toName,"to-params":_vm.toParams},on:{"click":_vm.onClick}},[_c('i',{staticClass:"fas fa-upload"}),_vm._v(" "+_vm._s(_vm.$t('upload'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }